import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';
import sliderADA from '../../components/slider/ada';

const playStopVideo = (current_slide_index) => {
  $('.hero-carousel__slide-main video').each(function ( index ) {
    $(this).get(0).pause();
  });

  window.setTimeout(() => {
    if ($(`.hero-carousel__slide-main[data-swiper-slide-index="${current_slide_index}"] video`).length > 0) {
      $(`.hero-carousel__slide-main[data-swiper-slide-index="${current_slide_index}"] video`).get(0).play();
    }
  }, 200);
};

export default () => {
  const swiper_slider = document.querySelector('[data-hero-carousel-slider].swiper');
  
  // Link on entire slide. Do not use touchend as it will trigger when swiping down (touchmove)
  $(document).on('click', '[data-hero-carousel-slide]', (e) => {
    const $item = $(e.currentTarget);
    if ((typeof $item.data('link') === 'undefined' || !$item.data('link').length) &&
        (typeof $item.data('link-mobile') === 'undefined' || !$item.data('link-mobile').length)) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    // Avoid triggering both events
    // if (e.type == 'touchend') {
    //   window.location.href = $item.data('link');
    // } else if (e.type == 'click') {
    if (window.theme.breakpoints.current === 'mobile' && typeof $item.data('link-mobile') !== 'undefined' && $item.data('link-mobile').length) {
      window.location.href = $item.data('link-mobile');
    } else if (typeof $item.data('link') !== 'undefined' && $item.data('link').length) {
      window.location.href = $item.data('link');
    }
  });

  if (!swiper_slider) {
    return false;
  }

  // Use ES5 in order to be able to use "this.realIndex"
  const swiper = new Swiper('[data-hero-carousel-slider].swiper', {
    modules: [ Navigation, Pagination, Autoplay, A11y ], // https://swiperjs.com/swiper-api#using-js-modules
    a11y: {
      enabled: true,
      prevSlideMessage: window.theme.strings.swiperPrevSlide,
      nextSlideMessage: window.theme.strings.swiperNextSlide,
      containerMessage: window.theme.strings.swiperContainer,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoHeight: true,
    // freeMode: true,
    autoplay: {
      delay: Number(swiper_slider.dataset.slideDelay || 10000),
      pauseOnMouseEnter: true,
    },
    // breakpoints: {
    //   1440: {
    //     freeMode: false,
    //   }
    // },
    // navigation: {
    //   nextEl: '.hero-carousel .swiper-button-next',
    //   prevEl: '.hero-carousel .swiper-button-prev',
    // },
    pagination: {
      el: '.hero-carousel .swiper-pagination',
      clickable: true,
    },
    on: {
      init: function () {
        // Swiper's a11y module sets aria-label on this container but not a
        // role, so on a plain <div> (implicit role="generic") the label is
        // silently ignored by assistive tech.
        this.el.setAttribute('role', 'region');
        playStopVideo(this.realIndex);
        sliderADA(swiper_slider);
      },
    }
  });

  swiper.on('slideChangeTransitionEnd', function () {
    playStopVideo(this.realIndex);
  });

  return true;
};
